export interface JobReadinessMaterialLine {
  sourceName: string;
  materialName: string;
  quantity: number;
  unitAbbr: string;
  trucks: number;
  hasPlant: boolean;
}

export interface JobReadinessJobRow {
  key: string;
  scheduledDate: string;
  jobPhaseId: string;
  jobId?: string | null;
  jobExternalId?: string | null;
  jobName?: string | null;
  checklistTotal: number;
  checklistOutstanding: number;
  confirmedWithClient: boolean;
  revenueScheduled: number;
  profitScheduled: number;
  materialLines: JobReadinessMaterialLine[];
}

export interface JobReadinessDailyTotal {
  scheduledDate: string;
  totalQuantity: number;
  totalTrucks: number;
  materialRows: JobReadinessMaterialLine[];
}

export interface JobReadinessSummary {
  revenueScheduled: number;
  profitScheduled: number;
  jobsScheduled: number;
  jobsConfirmedWithClient: number;
  jobsWithOutstandingChecklistItems: number;
  totalQuantity: number;
  totalTrucks: number;
}

export interface JobReadinessExceptions {
  jobsNotConfirmedWithClient: number;
  jobsMissingPlantAssignment: number;
  jobsMissingMaterialQuantity: number;
  materialLinesWithoutTrucks: number;
}

export interface JobReadinessDashboard {
  summary: JobReadinessSummary;
  exceptions: JobReadinessExceptions;
  jobs: JobReadinessJobRow[];
  dailyTotals: JobReadinessDailyTotal[];
}

export const emptyJobReadinessDashboard: JobReadinessDashboard = {
  summary: {
    revenueScheduled: 0,
    profitScheduled: 0,
    jobsScheduled: 0,
    jobsConfirmedWithClient: 0,
    jobsWithOutstandingChecklistItems: 0,
    totalQuantity: 0,
    totalTrucks: 0,
  },
  exceptions: {
    jobsNotConfirmedWithClient: 0,
    jobsMissingPlantAssignment: 0,
    jobsMissingMaterialQuantity: 0,
    materialLinesWithoutTrucks: 0,
  },
  jobs: [],
  dailyTotals: [],
};
